<template>
  <div>
    <div class="row" v-if="house.remarks">
      <div class="col">
        <p class="no-margin" v-on:click="fullTextShown = true">{{ propertyDetails }}<span v-if="!fullTextShown">... <span class="underline-hover">More</span></span></p>
      </div>
    </div>

    <!-- Rental -->
    <div v-if="house.special_circumstances === 'Rental' && Object.entries(rental).length !== 0 && rental.constructor === Object" class="row">
      <div class="col">
        <h5 class="detail-subsection"><span class="letter">R</span> Rental</h5>
      </div>
    </div>
    <ul v-if="house.special_circumstances === 'Rental' && Object.entries(rental).length !== 0 && rental.constructor === Object" class="row">
      <li class="col-6" v-for="(rent, name) in rental" v-bind:key="name + 'rental'">{{ name }}: {{ rent }}</li>
      <li class="col-6" v-if="house.tenant_pays && house.tenant_pays.length">Tenant Pays:
        <ul>
          <li class="col-6" v-for="name in house.tenant_pays" v-bind:key="name.id">{{ name }}</li>
        </ul>
      </li>
      <li class="col-6" v-if="house.owner_pays && house.owner_pays.length">Owner Pays:
        <ul>
          <li class="col-6" v-for="name in house.owner_pays" v-bind:key="name.id">{{ name }}</li>
        </ul>
      </li>
    </ul>

    <!-- Foreclosure -->
    <div v-if="house.special_circumstances === 'Foreclosure' && Object.entries(foreclosure).length !== 0 && foreclosure.constructor === Object" class="row">
      <div class="col">
        <h5 class="detail-subsection"><span class="letter">F</span> Foreclosure</h5>
      </div>
    </div>
    <ul v-if="house.special_circumstances === 'Foreclosure' && Object.entries(foreclosure).length !== 0 && foreclosure.constructor === Object" class="row">
      <li class="col-6" v-for="(fore, name) in foreclosure" v-bind:key="name + 'foreclosure'">{{ name }}: {{ fore }}</li>
    </ul>

    <!-- Off Market -->
    <div v-if="house.special_circumstances === 'Off Market' && Object.entries(offMarket).length !== 0 && offMarket.constructor === Object" class="row">
      <div class="col">
        <h5 class="detail-subsection"><span class="letter">O</span> Off Market</h5>
      </div>
    </div>
    <ul v-if="house.special_circumstances === 'Off Market' && Object.entries(offMarket).length !== 0 && offMarket.constructor === Object" class="row">
      <li class="col-6" v-for="(om, name) in offMarket" v-bind:key="name + 'offmarket'">{{ name }}: {{ om }}</li>
    </ul>

    <!-- Construction -->
    <div v-if="house.special_circumstances === 'New Construction' && Object.entries(constructionInfo).length !== 0 && constructionInfo.constructor === Object" class="row">
      <div class="col">
        <h5 class="detail-subsection"><span class="letter">N</span>New Construction</h5>
      </div>
    </div>
    <ul v-if="house.special_circumstances === 'New Construction' && Object.entries(constructionInfo).length !== 0 && constructionInfo.constructor === Object" class="row">
      <li class="col-6" v-for="(con, name) in constructionInfo" v-bind:key="name + 'constructionInfo'">{{ name }}: {{ con }}</li>
    </ul>

    <!-- Bedrooms -->
    <div v-if="bedrooms.length > 0" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-bed"></i>Bedrooms: {{ bedrooms.length }}</h5>
      </div>
    </div>
    <ul v-if="bedrooms.length > 0" class="row">
      <li class="col-6" v-for="(bedroom, index) in bedrooms" v-bind:key="index + 'bedrooms'">{{ bedroom }}</li>
    </ul>

    <!-- Bathrooms -->
    <div v-if="bathrooms.length > 0" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-bath"></i>Bathrooms: {{ bathrooms.length }}</h5>
      </div>
    </div>
    <ul v-if="bathrooms.length > 0" class="row">
      <li class="col-6" v-for="(bathroom, index) in bathrooms" v-bind:key="index + 'bathrooms'">{{ bathroom }}</li>
    </ul>

    <!-- kitchen and dining -->
    <div v-if="kitchenAndDining.length > 0" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-wine-glass"></i>Kitchen/Dining</h5>
      </div>
    </div>
    <ul v-if="kitchenAndDining.length > 0" class="row">
      <li class="col-6" v-for="(item, index) in kitchenAndDining" v-bind:key="index + 'knd'">{{ item }}</li>
    </ul>

    <!-- other rooms -->
    <div v-if="otherRooms.length > 0" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-couch"></i>Other Rooms</h5>
      </div>
    </div>
    <ul v-if="otherRooms.length > 0" class="row">
      <li class="col-6" v-for="(room, index) in otherRooms" v-bind:key="index + 'otherroom'">{{ room }}</li>
    </ul>

    <!-- heating and cooling -->
    <div v-if="Object.entries(heatingAndCooling).length !== 0 && heatingAndCooling.constructor === Object" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-thermometer-three-quarters"></i>Heating and Cooling</h5>
      </div>
    </div>
    <ul v-if="Object.entries(heatingAndCooling).length !== 0 && heatingAndCooling.constructor === Object" class="row">
      <li class="col-6" v-for="(item, name) in heatingAndCooling" v-bind:key="name + 'hnc'">{{ name }}: {{ item }}</li>
    </ul>

    <!-- appliances -->
    <div v-if="appliances.length > 0" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-blender"></i>Appliances</h5>
      </div>
    </div>
    <ul v-if="appliances.length > 0" class="row">
      <li class="col-6" v-for="(appliance, index) in appliances" v-bind:key="index + 'appliances'">{{ appliance }}</li>
    </ul>

    <!-- outside and lot features -->
    <div v-if="Object.entries(outside).length !== 0 && outside.constructor === Object" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-tree"></i>Outside and Lot Features</h5>
      </div>
    </div>
    <ul v-if="Object.entries(outside).length !== 0 && outside.constructor === Object" class="row">
      <li class="col-6" v-for="(item, name) in outside" v-bind:key="name + 'outside'">{{ name }}: {{ item }}<span v-if="name === 'Lot Size'"> ft<sup>2</sup></span></li>
    </ul>

    <!-- garage -->
    <div v-if="Object.entries(garage).length !== 0 && garage.constructor === Object" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-car"></i>Garage and Parking</h5>
      </div>
    </div>
    <ul v-if="Object.entries(garage).length !== 0 && garage.constructor === Object" class="row">
      <li class="col-6" v-for="(item, name) in garage" v-bind:key="name + 'garage'">{{ name }}: {{ item }}</li>
    </ul>

    <!-- amenities and community features -->
    <div v-if="Object.entries(amenities).length !== 0 && amenities.constructor === Object" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-table-tennis"></i>Amenities and Community Features</h5>
      </div>
    </div>
    <ul v-if="Object.entries(amenities).length !== 0 && amenities.constructor === Object" class="row">
      <li class="col-6" v-for="(item, name) in amenities" v-bind:key="name + 'amenities'">{{ name }}: {{ item }}</li>
    </ul>

    <!-- basement -->
    <div v-if="basement.length > 0" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-archive"></i>Basement</h5>
      </div>
    </div>
    <ul v-if="basement.length > 0" class="row">
      <li class="col-6" v-for="(item, index) in basement" v-bind:key="index + 'basement'">{{ item }}</li>
    </ul>

    <!-- other property features -->
    <div v-if="Object.entries(otherPropFeat).length !== 0 && otherPropFeat.constructor === Object" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-clipboard-list"></i>Other Property Features</h5>
      </div>
    </div>
    <ul v-if="Object.entries(otherPropFeat).length !== 0 && otherPropFeat.constructor === Object" class="row">
      <li class="col-6" v-for="(item, name) in otherPropFeat" v-bind:key="name + 'opf'">{{ name }}: {{ item }}</li>
    </ul>

    <!-- school information -->
    <div class="row" v-if="house.school_district || house.school_name">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-school"></i>School Information</h5>
      </div>
    </div>
    <ul v-if="house.school_district || house.school_name">
      <li class="no-margin">School: {{ house.school_district + ' - ' + house.school_name }}</li>
    </ul>

    <!-- financial information -->
    <div v-if="Object.entries(financialInformation).length !== 0 && financialInformation.constructor === Object" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-piggy-bank"></i>Financial Information</h5>
      </div>
    </div>
    <ul v-if="Object.entries(financialInformation).length !== 0 && financialInformation.constructor === Object" class="row">
      <li class="col-6" v-for="(item, name) in financialInformation" v-bind:key="name + 'fin'">{{ name }}: {{ item }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fullTextShown: false
    }
  },
  props: {
    house: Object
  },
  computed: {
    propertyDetails () {
      let limit = 300
      if (this.house.remarks && (this.house.remarks.length < limit || this.fullTextShown)) return this.house.remarks
      else if (this.house.remarks) return this.house.remarks.slice(0, limit)
      return ''
    },
    rental () {
      var rent = {}
      if (this.house.application_fee) {
        rent['Application Fee'] = this.house.application_fee
      }
      if (this.house.required_background_check) {
        rent['Background Check Required'] = 'Yes'
      }
      if (this.house.available_starting) {
        let availableStartingComponents = this.house.available_starting.split(/\D/)
        rent['Available Starting'] = availableStartingComponents[1] + '/' + availableStartingComponents[2] + '/' + availableStartingComponents[0]
      }
      if (this.house.min_lease_months) {
        rent['Minimum Lease Months'] = this.house.min_lease_months
      }
      if (this.house.smoking_permitted) {
        rent['Smoking Permitted'] = 'Yes'
      }
      if (this.house.laundry_availability) {
        rent['Laundry Availability'] = this.house.laundry_availability
      }
      if (this.house.security_deposit) {
        rent['Security Deposit'] = '$' + this.house.security_deposit
      }
      if (this.house.fees) {
        rent['Other Deposits/Fees'] = this.house.fees.join(', ')
      }
      if (this.house.prepaid_rent) {
        rent['Prepaid Rent'] = this.house.prepaid_rent
      }
      return rent
    },
    foreclosure () {
      var fore = {}
      if (this.house.special_listing_conditions && this.house.special_listing_conditions.includes('In Foreclosure')) {
        fore['Foreclosure'] = 'Yes'
      }
      if (this.house.special_listing_conditions && this.house.special_listing_conditions.includes('Short Sale')) {
        fore['Potential Short'] = 'Yes'
      }
      if (this.house.special_listing_conditions && this.house.special_listing_conditions.includes('Real Estate Owned')) {
        fore['Lender Owned'] = 'Yes'
      }
      return fore
    },
    offMarket () {
      var om = {}
      if (this.house.special_circumstances === 'Off Market' && this.house.price_history) {
        for (let index = 0; index < this.house.price_history.length; index++) {
          let currentDataPoint = this.house.price_history[index]
          if (currentDataPoint.description === 'Sold') {
            om['Last Sold'] = '$' + currentDataPoint.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            break
          }
        }
      }
      return om
    },
    constructionInfo () {
      var con = {}
      if (this.house.builder_name) {
        con['Builder Name'] = this.house.builder_name
      }
      if (this.house.projected_completion_date) {
        var compDate = new Date(this.house.projected_completion_date)
        con['Projected Completion Date'] = compDate.toDateString()
      }
      if (this.house.model_location) {
        con['Model Location'] = this.house.model_location
      }
      if (this.house.model_hours) {
        con['Model Hours'] = this.house.model_hours
      }
      if (this.house.low_price_range) {
        con['Low Price Range'] = '$' + this.house.low_price_range
      }
      if (this.house.high_price_range) {
        con['High Prce Range'] = '$' + this.house.high_price_range
      }
      return con
    },
    bedrooms () {
      if (this.house.bedrooms.length > 0) return this.house.bedrooms
      return []
    },
    bathrooms () {
      if (this.house.bathrooms.length > 0) return this.house.bathrooms
      return []
    },
    kitchenAndDining () {
      var knd = []
      if (this.house.kitchen) {
        knd.push(this.house.kitchen)
      }
      if (this.house.dining_room) {
        knd.push(this.house.dining_room)
      }
      if (this.house.dining_description.length > 0) {
        knd.push('Description: ' + this.house.dining_description.join(', '))
      }
      return knd
    },
    otherRooms () {
      var otrms = []
      if (this.house.other_rooms.length > 0) {
        otrms = this.house.other_rooms
      }
      if (this.house.furnished === 'Furnished') {
        otrms.push('Furnished')
      }
      return otrms
    },
    heatingAndCooling () {
      var hnc = {}
      if (this.house.cooling.length > 0) {
        hnc['Cooling'] = this.house.cooling.join(', ')
      }
      if (this.house.heating.length > 0) {
        hnc['Heating'] = this.house.heating.join(', ')
      }
      if (this.house.fuel.length > 0) {
        hnc['Fuel'] = this.house.fuel.join(', ')
      }
      if (this.house.fireplaces.length > 0) {
        hnc['# of Fireplaces'] = this.house.fireplace_count
      }
      if (this.house.fireplaces.length > 0) {
        hnc['Fireplace Description'] = this.house.fireplaces.join(', ')
      }
      return hnc
    },
    appliances () {
      if (this.house.appliances.length > 0) return this.house.appliances
      return []
    },
    outside () {
      var outside = {}
      if (this.house.exterior.length > 0) {
        outside['Exterior'] = this.house.exterior.join(', ')
      }
      if (this.house.fence.length > 0) {
        outside['Fencing'] = this.house.fence.join(', ')
      }
      if (this.house.outbuildings.length > 0) {
        outside['Outbuildings'] = this.house.outbuildings.join(', ')
      }
      if (this.house.lot_acres) {
        outside['Lot Size Acres'] = this.house.lot_acres
      }
      if (this.house.lot_sqft) {
        outside['Lot Size'] = this.house.lot_sqft
      }
      if (this.house.present_use) {
        outside['Present Use'] = this.house.present_use
      }
      if (this.house.frontage.length > 0) {
        outside['Frontage'] = this.house.frontage.join(', ')
      }
      if (this.house.lot_dimensions) {
        outside['Lot Dimensions'] = this.house.lot_dimensions
      }
      if (this.house.community_name) {
        outside['Community Name'] = this.house.community_name
      }
      if (this.house.waterfront_view.length > 0) {
        outside['Waterfront View'] = this.house.waterfront_view.join(', ')
      }
      if (this.house.waterfront_name) {
        outside['Waterfront Name'] = this.house.waterfront_name
      }
      if (this.house.lot_features.length > 0) {
        outside['Lot Description'] = this.house.lot_features.join(', ')
      }
      if (this.house.agricultural_water.length > 0) {
        outside['Agricultural Water'] = this.house.agricultural_water.join(', ')
      }
      return outside
    },
    garage () {
      var garage = {}
      if (this.house.garage.length > 0) {
        garage['Garage'] = this.house.garage.join(', ')
      }
      if (this.house.garage_stalls) {
        garage['Garage Stalls'] = this.house.garage_stalls
      }
      if (this.house.other_stalls) {
        garage['Other Stalls'] = this.house.other_stalls
      }
      if (this.house.garage_dimensions) {
        garage['Garage Dimensions'] = this.house.garage_dimensions
      }
      if (this.house.garage_door_height) {
        garage['Garage Door Height'] = this.house.garage_door_height
      }
      if (this.house.garage_door_width) {
        garage['Garage Door Width'] = this.house.garage_door_width
      }
      return garage
    },
    amenities () {
      var amenities = {}
      if (this.house.unit_amenities.length > 0) {
        amenities['Unit Amenities'] = this.house.unit_amenities.join(', ')
      }
      if (this.house.shared_amenities.length > 0) {
        amenities['Shared Amenities'] = this.house.shared_amenities.join(', ')
      }
      return amenities
    },
    basement () {
      if (this.house.basement.length > 0) return this.house.basement
      return []
    },
    otherPropFeat () {
      var opf = {}
      if (this.house.foundation_size) {
        opf['Foundation Size'] = this.house.foundation_size
      }
      if (this.house.roof.length > 0) {
        opf['Roof'] = this.house.roof.join(', ')
      }
      if (this.house.style) {
        opf['Style'] = this.house.style
      }
      if (this.house.mls_id) {
        opf['MLS ID'] = this.house.mls_id
      }
      if (this.house.parcel_id.length > 0) {
        opf['Parcel Number'] = this.house.parcel_id.join(', ')
      }
      if (this.house.water.length > 0) {
        opf['Water'] = this.house.water.join(', ')
      }
      if (this.house.county) {
        opf['County'] = this.house.county
      }
      if (this.house.neighborhood) {
        opf['Neighborhood'] = this.house.neighborhood
      }
      if (this.house.handicap_access.length > 0) {
        opf['Handicap Access'] = this.house.handicap_access.join(', ')
      }
      if (this.house.green_cert) {
        opf['Green Certified'] = this.house.green_cert
      }
      return opf
    },
    financialInformation () {
      var fin = {}
      if (this.house.assessment_pending) {
        fin['Assessment Pending'] = this.house.assessment_pending
      }
      if (this.house.hoa_fee) {
        fin['HOA Fee'] = '$' + this.house.hoa_fee
      }
      if (this.house.hoa_fee_frequency) {
        fin['HOA Fee Frequency'] = this.house.hoa_fee_frequency
      }
      if (this.house.hoa_company_name) {
        fin['HOA Company Name'] = this.house.hoa_company_name
      }
      if (this.house.hoa_benefits.length > 0) {
        fin['HOA Benefits'] = this.house.hoa_benefits.join(', ')
      }
      /* if (this.house.tax_history.length > 0) {
        fin['Tax History'] = this.house.tax_history
      }
      if (this.house.price_history.length > 0) {
        fin['Price History'] = this.house.price_history
      } */
      return fin
    }
  },
  watch: {
    propertyDetails: function (newValue) {
      if (this.house.remarks && newValue.length === this.house.remarks.length) this.fullTextShown = true
    }
  }
}
</script>

<style scoped>
.letter {
  float: left;
  width: 40px;
  font-size: 25px;
  font-family: 'Black Ops One', cursive !important;
}

.fas {
  width: 40px;
  font-size: 25px;
}

.detail-subsection {
  margin-top: 1rem;
}

.no-margin {
  margin: 0;
}

.underline-hover:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/dropdowns/PropertyDetails.vue